export const CALENDAR_TYPES = {
  single: 'single',
  range: 'range',
  from: 'from',
  to: 'to',
} as const;
